import { av } from "@adsk/lmv";

export class DtEventUtils extends av.EventUtils {
  static waitForFilteredEvent(target, type, filterCb, timeoutMs = 0) {
    return new Promise(async (resolve, reject) => {
      let timer;
      if (timeoutMs) {
        timer = setTimeout(() => {
          target.removeEventListener(type, listener);
          reject({ error: true, msg: 'timeout' });
        }, timeoutMs);
      }

      const listener = (e) => {
        if (!filterCb || filterCb(e)) {
          timer && clearTimeout(timer);
          target.removeEventListener(type, listener);
          resolve(e);
        }
      };

      target.addEventListener(type, listener);
    });
  }
}